var map = {
	"./badgecitizen.png": 9755,
	"./badgeexpatriate.png": 5117,
	"./badgenomad.png": 7192,
	"./badgetraveler.png": 3538,
	"./dialogueicon1.png": 9877,
	"./dialogueicon2.png": 1696,
	"./dialoguelesson.png": 207,
	"./grammarlesson.png": 7342,
	"./translateicon.png": 6098,
	"./videolesson.png": 5444,
	"./vocabularycount.png": 483,
	"./vocabularylesson.png": 6112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6003;